module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/inactive/hockey-b5cc5da7b69670db040bded5eb3cd5e0.svg";